import { create } from "zustand";
import { devtools, subscribeWithSelector, persist } from "zustand/middleware";

const useStore = create(
  devtools(
    subscribeWithSelector(
      persist(
        (set) => ({
          selects: {},
          dateRanges: {},
          sidebarExpandedKeys: {},
          setSidebarExpandedKey: (key, expanded) =>
            set((state) => ({
              sidebarExpandedKeys: {
                ...state.sidebarExpandedKeys,
                [key]: expanded,
              },
            })),
          peopleTreeData: null,
          categoryExpandedKeys: {},
          categorySelectedKey: null,

          setPeopleTreeData: (data) =>
            set(() => ({
              peopleTreeData: data,
            })),
          clearPeopleTreeData: () =>
            set(() => ({
              peopleTreeData: null,
            })),

          setCategoryExpandedKeys: (keys) =>
            set(() => ({
              categoryExpandedKeys: keys,
            })),
          setCategorySelectedKey: (key) =>
            set(() => ({
              categorySelectedKey: key,
            })),

          setSelectValue: (id, value, required, invalid = false) =>
            set((state) => ({
              selects: {
                ...state.selects,
                [id]: { value, required, invalid },
              },
            })),
          setDateRangeValue: (id, selection) =>
            set((state) => ({
              dateRanges: {
                ...state.dateRanges,
                [id]: { selection },
              },
            })),
          resetSelects: () =>
            set((state) => ({
              selects: Object.keys(state.selects).reduce((newSelects, id) => {
                newSelects[id] = { ...state.selects[id], value: "" };
                return newSelects;
              }, {}),
            })),
          removeSelect: (id) => {
            set((state) => {
              const newSelects = { ...state.selects };
              delete newSelects[id];
              return {
                selects: Object.keys(newSelects).length > 0 ? newSelects : {},
              };
            });
          },
        }),
        {
          name: "app-storage",
          partialize: (state) => ({
            categoryExpandedKeys: state.categoryExpandedKeys,
            categorySelectedKey: state.categorySelectedKey,
            sidebarExpandedKeys: state.sidebarExpandedKeys,
          }),
        },
      ),
    ),
  ),
);

export default useStore;
